import { useMutation } from '@tanstack/react-query';

import { useToastActions } from 'stores/toastStore';

type UseMutateWithToastProps = {
  mutationFn: (data: any) => Promise<any>;
  onSuccess?: (data?: any) => void;
  onError?: () => void;
  onSettled?: () => void;
};

const useMutateWithToast = ({ mutationFn, onSuccess, onError, onSettled }: UseMutateWithToastProps) => {
  const { addToast } = useToastActions();

  const { mutate, isPending } = useMutation({
    mutationFn,
    onSuccess,
    onError: () => {
      addToast({ text: 'Something went wrong. Please try again' });
      onError?.();
    },

    onSettled: () => {
      onSettled?.();
    },
  });

  return { mutate, isPending };
};

export default useMutateWithToast;
